module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Microphone_16"],"path":[{"$":{"d":"M9,14h3v2H4V14H7V12.51A5.61,5.61,0,0,1,2.4,7H3.6a4.4,4.4,0,1,0,8.8,0h1.2A5.61,5.61,0,0,1,9,12.51ZM8,10a3,3,0,0,0,3-3V3A3,3,0,0,0,5,3V7A3,3,0,0,0,8,10Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Microphone_16.svg
// module id = Zg+e
// module chunks = 1